var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotiValidacion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 204.564,
    height: 162.898,
    viewBox: "0 0 204.564 162.898",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_28590",
    "data-name": "Rect\\xE1ngulo 28590",
    width: 102,
    height: 72.098,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_59350",
    "data-name": "Grupo 59350",
    transform: "translate(-905 -428.799)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2077",
    "data-name": "Grupo 2077",
    transform: "translate(577.865 297.289)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3417",
    "data-name": "Trazado 3417",
    d: "M349.917,154.291a77.782,77.782,0,1,1,0,110,77.783,77.783,0,0,1,0-110Z",
    fill: "#d2d2d2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_44",
    "data-name": "Elipse 44",
    cx: 72.323,
    cy: 72.323,
    r: 72.323,
    transform: "translate(332.593 136.969)",
    fill: "#d2d2d2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_59341",
    "data-name": "Grupo 59341",
    transform: "translate(355.917 176.31)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_59341-2",
    "data-name": "Grupo 59341",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27566",
    "data-name": "Trazado 27566",
    d: "M99.052,3.282A10.592,10.592,0,0,0,91.371,0H10.629A10.63,10.63,0,0,0,0,10.628V61.466A10.637,10.637,0,0,0,10.629,72.1H91.371A10.63,10.63,0,0,0,102,61.466V10.628a10.584,10.584,0,0,0-2.948-7.346",
    transform: "translate(0 0.001)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27567",
    "data-name": "Trazado 27567",
    d: "M111.362,3.282,73.948,36.047l-6.3,5.52a6.582,6.582,0,0,1-8.672,0l-6.3-5.52L15.258,3.282A10.6,10.6,0,0,1,22.939,0h80.742a10.592,10.592,0,0,1,7.681,3.283",
    transform: "translate(-12.31 0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27568",
    "data-name": "Trazado 27568",
    d: "M111.37,219.356a10.6,10.6,0,0,1-7.681,3.283H22.947a10.582,10.582,0,0,1-7.679-3.285l37.413-32.765,6.3,5.52a6.582,6.582,0,0,0,8.672,0l6.3-5.52Z",
    transform: "translate(-12.318 -150.541)",
    fill: "#dcdee2"
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_8",
    "data-name": "L\\xEDnea 8",
    x1: 0.002,
    y2: 0.002,
    transform: "translate(2.948 68.813)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1907",
    "data-name": "Grupo 1907",
    transform: "translate(4.779 36)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2405",
    "data-name": "Trazado 2405",
    d: "M477.92,160.408a49,49,0,1,0,49,49A49,49,0,0,0,477.92,160.408Z",
    fill: "#78ac16"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1906",
    "data-name": "Grupo 1906"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2406",
    "data-name": "Trazado 2406",
    d: "M501.169,198.613,471.781,228a5.527,5.527,0,0,1-3.9,1.614,4.809,4.809,0,0,1-.635-.035,5.508,5.508,0,0,1-4.055-2.571l-9.311-15.015a5.515,5.515,0,0,1,9.373-5.814l5.649,9.1,24.469-24.464a5.516,5.516,0,1,1,7.91,7.689l-.11.111Z",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_59345",
    "data-name": "Grupo 59345",
    transform: "translate(-122 -1)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_519",
    "data-name": "Elipse 519",
    cx: 18,
    cy: 18,
    r: 18,
    transform: "translate(1043 460)",
    fill: "#d5007f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "notifications_24dp_5F6368",
    transform: "translate(1050 467)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27569",
    "data-name": "Trazado 27569",
    d: "M0,0H22.5V22.5H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27570",
    "data-name": "Trazado 27570",
    d: "M11.526,20.781A1.881,1.881,0,0,0,13.4,18.906H9.651A1.874,1.874,0,0,0,11.526,20.781Zm5.625-5.625V10.469c0-2.878-1.538-5.288-4.219-5.925V3.906a1.406,1.406,0,0,0-2.813,0v.638C7.429,5.181,5.9,7.581,5.9,10.469v4.687L4.691,16.366a.938.938,0,0,0,.656,1.6H17.695a.94.94,0,0,0,.666-1.6Z",
    transform: "translate(-0.276 -0.156)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotiValidacion);
export default __webpack_public_path__ + "static/media/Noti_validacion.b19816630adb21100f66eed2bc5c9069.svg";
export { ForwardRef as ReactComponent };